import styled from 'styled-components';

export const BrazeContentCardWrapper = styled('div')`
  .braze-content-card {
    margin-top: ${({ theme }) => `${theme.x2spacePx}px`};
    margin-bottom: ${({ theme }) => `${theme.x2spacePx}px`};
    background-color: ${({ theme }) => theme.color.almostBlack};
    border-radius: 8px;

    & .is-selected > div {
      margin-bottom: 0;
    }
  }
`;
